import { useState } from 'react';

/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-06-07 09:41:51
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-06-07 16:17:00
 */
export enum PagePath {
  login = 1,
  register = 2,
  forgotPssword = 3,
  home = 4,
}
export default () => {
  const [pagePath, setPagePath] = useState<PagePath>(0);
  return {
    pagePath,
    setPagePath,
  };
};
